import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isObject from '@cotyorg/ccx-utils/js/helpers/isObject';
import isServer from '@cotyorg/ccx-utils/js/helpers/isServer';
import styleVariables from '../scss/_navigation-variables.share-with-js.scss';

const mobileNavigationTransitionDuration = parseInt(styleVariables.mobileNavigationTransitionDuration, 10);
const rootSlug = 'root-slug';

class MobileNavigation extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      navigation,
      isVisible,
      showPage,
      hideAll,
      goBackDone,
    } = nextProps;

    if (!navigation || !Array.isArray(navigation.displayedPages)) {
      return prevState;
    }

    if (isVisible && !navigation.displayedPages.length) {
      showPage(rootSlug);
    } else if (!isVisible && navigation.displayedPages.length) {
      hideAll();

      // Use setTimeout in case onTransitionEnd does not fire.
      // This can occur when the mobile nav is toggled-on at mobile width
      // and toggled-off at desktop width where it does not have layout
      // and therefore the onTransitionEnd event does not fire.
      setTimeout(goBackDone, mobileNavigationTransitionDuration);
    }

    return prevState;
  }

  render() {
    const {
      navigation,
      isVisible,
      showPage,
      goBack,
      goBackDone,
      PageComponent,
      rightChevronIconSrc,
      leftChevronIconSrc,
      plusIconSrc,
      minusIconSrc,
      disableSwipe,
    } = this.props;

    if (!isObject(navigation)) {
      return null;
    }

    const className = classNames('mobile-navigation', {
      'mobile-navigation--visible': isVisible || navigation.goingBack,
    });

    if (!isServer && isVisible) {
      document.body.classList.add('body--mobile-nav-active');
    } else if (!isServer) {
      document.body.classList.remove('body--mobile-nav-active');
    }

    return (
      <nav className={className}>
        <PageComponent
          page={{
            pages: navigation.pages,
            slug: rootSlug,
            url: '/',
            name: '',
          }}
          nested={false}
          navigation={navigation}
          showPage={showPage}
          goBack={goBack}
          goBackDone={goBackDone}
          leftChevronIconSrc={leftChevronIconSrc}
          rightChevronIconSrc={rightChevronIconSrc}
          plusIconSrc={plusIconSrc}
          minusIconSrc={minusIconSrc}
          disableSwipe={disableSwipe}
        />
      </nav>
    );
  }
}

MobileNavigation.propTypes = {
  navigation: PropTypes.shape({
    pages: PropTypes.array.isRequired,
    displayedPages: PropTypes.array.isRequired,
    goingBack: PropTypes.bool,
  }),
  isVisible: PropTypes.bool.isRequired,
  showPage: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  goBackDone: PropTypes.func.isRequired,
  PageComponent: PropTypes.func.isRequired,
  rightChevronIconSrc: PropTypes.string,
  leftChevronIconSrc: PropTypes.string,
  plusIconSrc: PropTypes.string,
  minusIconSrc: PropTypes.string,
  disableSwipe: PropTypes.bool,
};

export default MobileNavigation;
